module.exports = __webpack_public_path__ + "img/bg.a0a41ced.png";